import { useState } from 'react'
import { useDebounce } from 'react-use'
import useAccount from 'hooks/useAccount'
import { Bounds } from 'hooks/useMapBounds'
import {
  ClustersForBoundsQuery,
  useClustersForBoundsLazyQuery
} from 'generated/graphql'

const useMapData = (bounds: Bounds) => {
  const [boundsData, setBoundsData] = useState<ClustersForBoundsQuery>()

  const { accountId } = useAccount()

  const [fetchClustersForBounds, result] = useClustersForBoundsLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted(data) {
      if (!data) {
        return
      }

      setBoundsData(data)
    }
  })

  useDebounce(
    () => {
      if (!accountId) {
        return
      }
      setBoundsData(undefined)
      fetchClustersForBounds({ variables: { accountId, ...bounds } })
    },
    200,
    [bounds]
  )

  const points = boundsData?.clustersForBounds?.points ?? []
  const clusters = boundsData?.clustersForBounds?.clusters ?? []

  return { ...result, points, clusters } as const
}

export default useMapData
